export default __webpack_public_path__ + "static/sobbingShielding-2e4e2417cd5d5d656c0a7cf771c65da1.svg";